<template>
  <div class="project-header">
    <div class="pageHeader">
      <div class="left-wrap">
        <i
          class="el-icon-back"
          @click="$router.push({ name: 'company-manage-project-template' })"
        ></i>
        <div class="project-info" @click="openEditProjectDialog">
          <div class="name">
            {{ projectInfo.name }}
          </div>
          <div class="desc">
            {{ projectInfo.templateDesc }}
          </div>
        </div>
      </div>
      <tabs :tab-list="tabs" :default-active="defaultActive" @click="changeTab" class="tabs"></tabs>
      <div class="operate"></div>
    </div>
    <edit-project-dialog
      :project-info="projectInfo"
      ref="editProjectDialog"
      @submit="editProject"
    ></edit-project-dialog>
  </div>
</template>

<script>
import Tabs from "@/components/UIComponents/Tab"
import { templateTabs } from "@/views/Front/Project/Layout/static"
import EditProjectDialog from "./EditProjectDialog"
import { updateProject } from "@/api/project/project"

export default {
  name: "ProjectHeader",
  components: {
    Tabs,
    EditProjectDialog
  },
  props: {
    projectInfo: {
      type: Object,
      required: true
    },
    defaultActive: String
  },
  data() {
    return {
      tabs: templateTabs
    }
  },
  methods: {
    changeTab(tab) {
      let projectId = this.projectInfo.id
      if (tab == "TaskList") {
        this.$router.replace({
          name: "project-task-list",
          params: { projectId },
          query: { template: "true" } // 用来初始化layout中的template变量默认值,防止标题栏闪烁
        })
      } else if (tab == "Setting") {
        this.$router.replace({
          name: "admin-project-task-group",
          params: { projectId },
          query: { template: "true" } // 用来初始化layout中的template变量默认值,防止标题栏闪烁
        })
      }
    },
    openEditProjectDialog() {
      this.$refs.editProjectDialog?.open()
    },
    editProject(newProject) {
      updateProject(newProject, this.projectInfo.id).then(project => {
        this.$set(this.projectInfo, "name", project.name)
        this.$set(this.projectInfo, "templateDesc", project.templateDesc)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.project-header {
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: $navbar-height;
  top: 0;
  .pageHeader {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    background: #fff;
    .left-wrap {
      display: flex;
      align-items: center;
      .el-icon-back {
        margin-right: 15px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
      .project-info {
        cursor: pointer;
        .name {
          font-size: 17px;
        }
        .desc {
          font-size: 12px;
          color: #9e9e9e;
        }
      }
    }
    ::v-deep {
      .tab {
        position: absolute;
        left: 50%;
        .tab-item {
          height: unset;
          .tab-title {
            height: unset;
            line-height: calc(#{$navbar-height} - 24px);
            padding: 10px;
          }
        }
      }
    }
  }
}
</style>
